(function($, App, Utils, Components) {
  'use strict';
  
  var logger = new Logger("Popovers");
  
  var closingTimer = null;
  
  Components.create("Popovers", {
    
    defaultSelector: 'data-popover-target',
    
    popoverOpenEvent: "popover:open",
    
    popoverCloseEvent: "popover:close",
    
    popoverCloseEventAll: "popover:close:all",
    
    popoverBeforeOpenEvent: "popover:beforeshow",
    
    bindEvents: function() {
      
      Utils.Responsive.on(Utils.Responsive.Events.ResolutionEnter + '.popovers', function(e, res) {
        Components.Popovers.unbindPopovers();
        Components.Popovers.setSelector(res);
        Components.Popovers.bindPopovers();
      });
      
      $(Components.Popovers.selector + ', *[data-popover-anchor], .popover').on('mouseleave.popovers', function(e) {
        var eventType = e.type; // store event type here before jquery restores it to its original value.
        clearTimeout(closingTimer);
        closingTimer = setTimeout(function() {
          Components.Popovers.hideAll(false, eventType);
          App.Body.one('click.popovers', function(e) {
            return Components.Popovers.hideAll(false, e.type);
          });
        }, 250);
      });
      
      App.Window.on('resize.popovers', function(e) {
        Components.Popovers.hideAll(false, e.type);
      }).on('keydown.popovers', function (e) {
        if (/27/.test(e.which)) {
          Components.Popovers.hideAll(true, e.type);
        }
      });
      
      Components.Popovers.bindPopovers();
    },
    
    
    bindPopovers: function() {
      
      var evts = 'mouseenter.popovers click.popovers';
      if (App.Html.hasClass('touchevents')) {
        evts = 'click.popovers';
      }
      
      $(Components.Popovers.selector).on(evts, function(e) {
        logger.debug("Handling:", e.type);
        clearTimeout(closingTimer);
        
        var
          self = $(this),
          skipHover = self.data('popoverSkipHover');
        
        if (skipHover && e.type == 'mouseenter') {
          return;
        }
        
        var $target = Components.Popovers.getTarget(self);
        
        if ($target.is('.in') && e.type == 'click') {
          logger.info("Element was already shown, hiding...");
          Components.Popovers.hide(this, true);
          $(Components.Popovers.selector).removeClass('active');
          return;
        } else if (App.Html.hasClass('touchevents')) {
          e.preventDefault();
        }
        
        Components.Popovers.hideAll(true);
        Components.Popovers.show(this);
        
      }).on('keydown.popovers', function(e) {
        Components.Popovers.keystroke.call(this, e);
      });
      
      $(Components).on("overlays:close", function(e) {
        logger.debug("Caught 'overlays:close'");
        Components.Popovers.hideAll(true);
      })
    },
    
    unbindPopovers: function() {
      
      var evts = 'mouseenter.popovers click.popovers';
      if (App.Html.hasClass('touchevents')) {
        evts = 'click.popovers';
      }
      
      $(Components.Popovers.selector).off(evts);
      
    },
    
    
    hideAll: function(force, eventType) {
      $(Components.Popovers.selector).each(function(i, e) {
        Components.Popovers.hide(e, force, true, eventType);
      });
      
      App.Window.trigger(Components.Popovers.popoverCloseEventAll);
    },
    
    
    hide: function(toggler, force, skipEvent, eventType, focusSelf) {
      
      if ($('*[data-popover-target]:hover, *[data-popover-anchor]:hover, .popover:hover, .popover input:focus').length != 0 && !force) {
        // logger.debug("Skipping hide because 'hovering' or 'focusing' detected.");
        return false;
      }
      
      var
        self = $(toggler),
        skipHover = self.data('popoverSkipHover');
      
      var $target = Components.Popovers.getTarget(self);
      $target.off('keydown.popovers');
      
      if (!(skipHover && eventType == 'mouseleave') && $target.is('.in')) {
        logger.debug("Hiding", $target);
        self.removeClass('active');
        self.attr('aria-expanded', 'false');
        $target.removeClass('in');
        $target.attr('aria-hidden', 'true');
      }
      
      if (!skipEvent) {
        App.Window.trigger(Components.Popovers.popoverCloseEvent, [self, $target]);
        $target.trigger(Components.Popovers.popoverCloseEvent, [self]);
      }
      
      if (force) {
        self.removeClass('active');
        App.Html.removeClass(self.data('toggleHtmlClass'));
      }
      
      if (focusSelf) {
        Components.Popovers.openTrigger.focus();
      }
    },
    
    show: function(toggler) {
      
      Components.trigger('overlays:close');
      
      var
        self = $(toggler),
        target = self.data(Components.Popovers.targetDataAttr) || self.data('popoverTarget'),
        $target = Components.Popovers.getTarget(self),
        remote = $target.data('remote'),
        remoteCallback = $target.data('remoteCallback'),
        disabled = $target.data('disabled') || false;
      
      if ($target.length == 0) {
        logger.warn("Target '%s' not found, giving up...", target);
        return;
      }
      
      logger.log("Target disabled:", disabled);
      
      if (target == 'dismiss' || disabled) {
        return;
      }
      
      
      if (remote) {
        $.ajax({
          url: remote,
          beforeSend: function(jqXHR, settings) {
            settings['hideLoading'] = self.data('popoverHideloading');
          }
        }).then(function(data, status, xhr) {
          $target
            .empty()
            .removeAttr('data-remote')
            .append(data)
            .data('remote', null);
          Components.Popovers.unbindPopovers();
          Components.Popovers.bindPopovers();
          Components.Popovers.completeShow(self, $target);
          
          if (remoteCallback) {
            eval(remoteCallback);
          }
        });
      }
      
      
      logger.debug("Showing", target);
      
      self.addClass('active');
      self.attr('aria-expanded', 'true');
      $target.addClass('in');
      $target.attr('aria-hidden', 'false');
      App.Html.addClass(self.data('toggleHtmlClass'));
      
      $target.on('keydown.popovers', function(e) {
        if (/27/.test(e.which) && !/input|textarea/i.test(e.target.tagName)) {
          Components.Popovers.hide(toggler, true, true, e, true);
        }
      });
      
      if (!remote) {
        Components.Popovers.completeShow(self, $target);
      }
      
    },
    
    completeShow: function(element, target) {
      setTimeout(function() {
        var
          focustarget = element.data('popoverFocus') || ':focusable',
          $focustarget = target.find(focustarget).first();
        
        if ($focustarget.length > 0) {
          logger.debug("Focusing", $focustarget);
          $focustarget.focus();
        }
        
        App.Window.trigger(Components.Popovers.popoverOpenEvent, [element, target]);
        Components.Popovers.trigger(Components.Popovers.popoverOpenEvent, [element, target]);
        
      }, 250);
    },
    
    keystroke: function(e) {
      
      if (!/(38|40|27|32|13)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;
      
      var self = $(this);
      
      e.preventDefault();
      e.stopPropagation();
      
      var $target = Components.Popovers.getTarget(self);
      var isActive = $target.is('.in');
      
      if (e.type === 'keydown' && e.which !== 27) {
        Components.Popovers.openTrigger = self;
      }
      
      if (!isActive && e.which !== 27 || isActive && e.which === 27) {
        self.trigger('click.popovers');
      }
    },
    
    getTarget: function(element) {
      var target = $(element).data(Components.Popovers.targetDataAttr);
      
      if (!target) {
        target = $(element).data('popoverTarget');
      }
      
      if (target.match(/^#/)) {
        return $(target);
      } else {
        return $(element).closest($(element).data('context')).find(target);
      }
    },
    
    setSelector: function(res) {
      res = res ? res : Utils.Responsive.getCurrentResolution();
      Components.Popovers.selector =
        '*[' + Components.Popovers.defaultSelector + '],' +
        '*[' + Components.Popovers.defaultSelector + '-' + res.label + ']';
      Components.Popovers.targetDataAttr = 'popoverTarget' + Utils.Inflector.capitalize(res.label);
      logger.info("New selector", Components.Popovers.selector);
    },
    
    init: function() {
      Utils.Responsive.on(Utils.Responsive.Events.Ready, function() {
        Components.Popovers.setSelector();
        Components.Popovers.bindEvents();
      });
    }
    
  });
  
})(jQuery,
  window.App,
  window.App.Utils,
  window.App.Components
);
